import React, { useCallback, useRef } from "react";
import { connect } from "react-redux";
import FormField from "../../../../dynamicFormBuilder/FormField";
import { PrimaryLayout } from "../Layout";

function PrimaryTab(props) {
    const currentUser = props.oidc.user;
    const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    // FormField calls onFormLoad() with no args; forward this tab's formRefs to the parent
    // so it can populate the Entry Mode dropdown once the widgets are rendered.
    const handleFormLoad = useCallback(() => {
        props.handlePrimaryFormLoad(formRefs);
    }, []);

    const handleFieldChange = useCallback((name, value, e) => {
        if (props.handleFieldChange) {
            props.handleFieldChange(name, value, e, formRefs);
        }
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId="B7E4C2A9-6D31-4F08-9A25-3C8E1D5B70F6"
                layoutName="WMLaborTrackingPrimaryForm"
                defaultFormSchema={PrimaryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(PrimaryTab);
